module.exports = __webpack_public_path__ + "img/medfinder.7d3e1106.png";